// @generated by protoc-gen-es v2.14.0 with parameter "target=ts"
// @generated from file history.proto (package history.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file history.proto.
 */
export const file_history: GenFile = /*@__PURE__*/
  fileDesc("Cg1oaXN0b3J5LnByb3RvEgpoaXN0b3J5LnYxIvMBChZCdWNrZXRlZEhpc3RvcnlSZXF1ZXN0Eg4KBmVudGl0eRgBIAEoCRIPCgdwcm9qZWN0GAIgASgJEhIKCnJ1bl9maWx0ZXIYAyABKAkSDQoFc3BlY3MYBCADKAkSEgoFbGltaXQYBiABKAVIAIgBARISCgVvcmRlchgHIAEoCUgBiAEBEhQKDGN1cnJlbnRfcnVucxgIIAMoCRIZCgxsYXN0X3VwZGF0ZWQYCSABKAlIAogBAUIICgZfbGltaXRCCAoGX29yZGVyQg8KDV9sYXN0X3VwZGF0ZWRKBAgFEAZSEXByaW1hcnlfbGluZV90eXBlIrMBChJSdW5CdWNrZXRlZEhpc3RvcnkSEAoIcnVuX25hbWUYASABKAkSEwoLc3BlY3NfYXJyb3cYAiADKAwSEgoKaW5jb21wbGV0ZRgDIAEoCBISCgp1cGRhdGVkX2F0GAQgASgJEhQKDGRpc3BsYXlfbmFtZRgFIAEoCRIgChNkZWZhdWx0X2NvbG9yX2luZGV4GAYgASgFSACIAQFCFgoUX2RlZmF1bHRfY29sb3JfaW5kZXgiVgoXQnVja2V0ZWRIaXN0b3J5UmVzcG9uc2USLAoEcnVucxgBIAMoCzIeLmhpc3RvcnkudjEuUnVuQnVja2V0ZWRIaXN0b3J5Eg0KBW9yZGVyGAIgAygJIlAKFEJ1Y2tldGVkSGlzdG9yeUNodW5rEhAKCHJ1bl9uYW1lGAEgASgJEhIKCnNwZWNfaW5kZXgYAiABKA0SEgoKc3BlY19hcnJvdxgDIAEoDDLQAQoOSGlzdG9yeVNlcnZpY2USXQoSR2V0QnVja2V0ZWRIaXN0b3J5EiIuaGlzdG9yeS52MS5CdWNrZXRlZEhpc3RvcnlSZXF1ZXN0GiMuaGlzdG9yeS52MS5CdWNrZXRlZEhpc3RvcnlSZXNwb25zZRJfChVTdHJlYW1CdWNrZXRlZEhpc3RvcnkSIi5oaXN0b3J5LnYxLkJ1Y2tldGVkSGlzdG9yeVJlcXVlc3QaIC5oaXN0b3J5LnYxLkJ1Y2tldGVkSGlzdG9yeUNodW5rMAFCNFoyZ2l0aHViLmNvbS93YW5kYi9jb3JlL3NlcnZpY2VzL2dvcmlsbGEvYXBpL2hpc3RvcnliBnByb3RvMw");

/**
 * @generated from message history.v1.BucketedHistoryRequest
 */
export type BucketedHistoryRequest = Message<"history.v1.BucketedHistoryRequest"> & {
  /**
   * @generated from field: string entity = 1;
   */
  entity: string;

  /**
   * @generated from field: string project = 2;
   */
  project: string;

  /**
   * @generated from field: string run_filter = 3;
   */
  runFilter: string;

  /**
   * @generated from field: repeated string specs = 4;
   */
  specs: string[];

  /**
   * @generated from field: optional int32 limit = 6;
   */
  limit?: number | undefined;

  /**
   * @generated from field: optional string order = 7;
   */
  order?: string | undefined;

  /**
   * @generated from field: repeated string current_runs = 8;
   */
  currentRuns: string[];

  /**
   * @generated from field: optional string last_updated = 9;
   */
  lastUpdated?: string | undefined;
};

/**
 * Describes the message history.v1.BucketedHistoryRequest.
 * Use `create(BucketedHistoryRequestSchema)` to create a new message.
 */
export const BucketedHistoryRequestSchema: GenMessage<BucketedHistoryRequest> = /*@__PURE__*/
  messageDesc(file_history, 0);

/**
 * @generated from message history.v1.RunBucketedHistory
 */
export type RunBucketedHistory = Message<"history.v1.RunBucketedHistory"> & {
  /**
   * @generated from field: string run_name = 1;
   */
  runName: string;

  /**
   * @generated from field: repeated bytes specs_arrow = 2;
   */
  specsArrow: Uint8Array[];

  /**
   * @generated from field: bool incomplete = 3;
   */
  incomplete: boolean;

  /**
   * @generated from field: string updated_at = 4;
   */
  updatedAt: string;

  /**
   * @generated from field: string display_name = 5;
   */
  displayName: string;

  /**
   * @generated from field: optional int32 default_color_index = 6;
   */
  defaultColorIndex?: number | undefined;
};

/**
 * Describes the message history.v1.RunBucketedHistory.
 * Use `create(RunBucketedHistorySchema)` to create a new message.
 */
export const RunBucketedHistorySchema: GenMessage<RunBucketedHistory> = /*@__PURE__*/
  messageDesc(file_history, 1);

/**
 * @generated from message history.v1.BucketedHistoryResponse
 */
export type BucketedHistoryResponse = Message<"history.v1.BucketedHistoryResponse"> & {
  /**
   * @generated from field: repeated history.v1.RunBucketedHistory runs = 1;
   */
  runs: RunBucketedHistory[];

  /**
   * @generated from field: repeated string order = 2;
   */
  order: string[];
};

/**
 * Describes the message history.v1.BucketedHistoryResponse.
 * Use `create(BucketedHistoryResponseSchema)` to create a new message.
 */
export const BucketedHistoryResponseSchema: GenMessage<BucketedHistoryResponse> = /*@__PURE__*/
  messageDesc(file_history, 2);

/**
 * @generated from message history.v1.BucketedHistoryChunk
 */
export type BucketedHistoryChunk = Message<"history.v1.BucketedHistoryChunk"> & {
  /**
   * @generated from field: string run_name = 1;
   */
  runName: string;

  /**
   * @generated from field: uint32 spec_index = 2;
   */
  specIndex: number;

  /**
   * @generated from field: bytes spec_arrow = 3;
   */
  specArrow: Uint8Array;
};

/**
 * Describes the message history.v1.BucketedHistoryChunk.
 * Use `create(BucketedHistoryChunkSchema)` to create a new message.
 */
export const BucketedHistoryChunkSchema: GenMessage<BucketedHistoryChunk> = /*@__PURE__*/
  messageDesc(file_history, 3);

/**
 * @generated from service history.v1.HistoryService
 */
export const HistoryService: GenService<{
  /**
   * @generated from rpc history.v1.HistoryService.GetBucketedHistory
   */
  getBucketedHistory: {
    methodKind: "unary";
    input: typeof BucketedHistoryRequestSchema;
    output: typeof BucketedHistoryResponseSchema;
  },
  /**
   * @generated from rpc history.v1.HistoryService.StreamBucketedHistory
   */
  streamBucketedHistory: {
    methodKind: "server_streaming";
    input: typeof BucketedHistoryRequestSchema;
    output: typeof BucketedHistoryChunkSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_history, 0);

